import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isSaved = false;
		state.isPqyUser = false;

		state.searchParams = SEARCH_PARAMS();
		state.selectedRow = SELECTED_ROW();
		state.pagingInfo = PAGING_INFO();
		state.badClCdList = [];
		state.badScnCdList = [];
		state.powCdList = [];
		state.resultList = [];
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	}
};
